export const AUTH_LOGGED_IN_TOAST_TRIGGER = "auth-signed-in";

/**
 * Used by the Directory to prefill the search via query string.
 *
 * Basic:
 * @example ?explore=beginners
 *
 * Opening a series directly (prefix `:series`):
 * @example ?explore=series:beginners%20challenge
 */
export const TOOLBAR_SHOW_EXPLORE = "explore";

/**
 * Used by the onboarding flow to hide the "Learn background" and allow users to view projects
 */
export const ONBOARDING_HIDE_BG = "o-hbg";

/**
 * Used to save the last viewed project ID to local storage
 */
export const LAST_VIEWED_PROJECT = "last-viewed-project";
